<template>
  <div v-if="computedSnowmakingImagesVisibility">
    <v-dialog
      v-model="computedSnowmakingImagesVisibility"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="methodToggleListView('snowmaking', 'images')">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Snowmaking Images</v-toolbar-title
          >
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-btn @click="addImage = true" color="info">Add Image</v-btn>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="search"
            placeholder="Filter data"
          ></v-text-field>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            :headers="headers"
            :items="computedSnowmakingImagesGeoJsonFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            :search="search"
            class="elevation-1"
            :loading="computedSnowmakingImagesLoading"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'snowmaking',
                    'images',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.title }}</td>
              </tr>
            </template>

            <!-- Alert when no results found -->
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <!-- ADD IMAGE DIALOG -->
    <v-dialog
      v-model="addImage"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addImage = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              base64image = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Add Image</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addImage"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Image</td>
                <td>
                  <image-uploader
                    @input="setOutput"
                    :quality="0.7"
                    :autoRotate="attemptAutoRotate"
                    outputFormat="base64"
                    class="fileinput2"
                    :preview="true"
                    accept=".jpg, .jpeg"
                    :key="attemptAutoRotate"
                  ></image-uploader>
                </td>
              </tr>
              <tr>
                <td>EXIF rotate?</td>
                <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>
                  <v-select
                    ref="ref_category"
                    v-model="form.category"
                    :items="opt_category"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Title</td>
                <td>
                  <v-text-field ref="ref_title" v-model="form.title" />
                </td>
              </tr>
              <tr>
                <td>Description</td>
                <td>
                  <v-textarea
                    ref="ref_description"
                    v-model="form.description"
                  ></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddSnowmakingImagesGeoJson({
                        lat: lat,
                        lng: lng,
                        accuracy: 3,
                        category: form.category,
                        title: form.title,
                        description: form.description,
                        created: Date.now(),
                        created_by: computedAuth.profile.email,
                        base64data: base64image
                      });
                      addImage = false;
                      clearWatchLocation();
                      lat = null;
                      lng = null;
                      accuracy = null;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.fileinput2 {
  color: green;
}
</style>
<script>
("dataSnowmakingImages");
export default {
  data() {
    return {
      attemptAutoRotate: false,
      form: {
        category: null,
        title: null,
        description: null
      },
      base64image: null,
      lat: null,
      lng: null,
      accuracy: null,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      watchId: null,
      tracking: false,
      addImage: false,
      loading: true,
      search: "",
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Title",
          value: "properties.zone"
        }
      ],
      opt_category: [
        { text: "Underground" },
        { text: "Maintenance" },
        { text: "Operations" },
        { text: "Default" }
      ]
    };
  },
  computed: {
    computedSnowmakingImagesGeoJsonFeatures() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.images.geojson.features
      ) {
        const images = this.$store.state.mapLayers.snowmaking.layers.images
          .geojson.features;

        let hideHidden = images.filter(item => item.properties.hidden != "t");
        return hideHidden;
      }
      return [];
    },
    computedSnowmakingImagesVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.images.visibility
        .listView;
    },
    computedSnowmakingImagesLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.images.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    pgDate(date) {
      function zeroPad(d) {
        return ("0" + d).slice(-2);
      }

      var parsed = new Date(date);

      return [
        parsed.getUTCFullYear() +
          "-" +
          zeroPad(parsed.getMonth() + 1) +
          "-" +
          zeroPad(parsed.getDate()) +
          " " +
          zeroPad(parsed.getHours()) +
          ":" +
          zeroPad(parsed.getMinutes()) +
          ":" +
          zeroPad(parsed.getSeconds())
      ].join(" ");
    },
    setOutput(file) {
      this.base64image = file;
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (utcdate !== null) {
        return y + "-" + m + "-" + d;
      } else {
        return;
      }
    },
    // method to get geojson
    methodGetSnowmakingImagesGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/images",
        dept: "snowmaking",
        layer: "images",
        token: this.computedAuthToken
      });
    },
    methodAddSnowmakingImagesGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.lng, data.lat]
            },
            properties: {
              category: data.category,
              title: data.title,
              description: data.description,
              accuracy: data.accuracy,
              created: this.getNormalDate(data.created),
              created_by: data.created_by
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddJsonImage", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images",
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/image",
          base64data: this.base64image,
          dept: "snowmaking",
          layer: "images",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          setTimeout(() => {
            this.methodGetSnowmakingImagesGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.images.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingImagesGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.images.geojson": function(
      newValue
    ) {
      if (
        newValue &&
        this.$store.state.mapLayers.snowmaking.layers.images.geojson
      ) {
        this.loading = false;
      }
    }
  }
};
</script>
